import React from 'react'
import { t } from 'react-i18nify'

export const translate = (key: string): string => {
  const translation = t(key, undefined, { returnNullOnError: true })
  if (translation !== null) return translation
  const enTranslation = t(key, undefined, { locale: 'en', returnNullOnError: true })
  if (enTranslation !== null) return enTranslation
  const frTranslation = t(key, undefined, { locale: 'fr' })
  return frTranslation
}

export const Translate: React.FC<{ value: string }> = ({ value }) => {
  const translation = translate(value)

  // Defensively handle a non-string translation (e.g. missing key)
  if (typeof translation !== 'string') return <>{translation}</>

  // Render newline characters (\n or \r\n) coming from the locale files as
  // real line breaks. A double newline therefore produces an empty line.
  const lines = translation.split(/\r?\n/)

  return (
    <>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {index > 0 && <br />}
          {line}
        </React.Fragment>
      ))}
    </>
  )
}
